import { config } from '../../config/global'

import { FORM_1_SUBMIT, PAGE_VIEW, FORM_2_SUBMIT } from './constants'

type GTMStore = {
  event?: string
  pageUrlPath?: string
  pageType?: string
  // eslint-disable-next-line
  LP_Version?: string
  // eslint-disable-next-line
  LP_Variation?: string
  formElements?: number
  cityEntered?: string
  vehicleEntered?: string
  formLocation?: string
  Brand?: string
}

let store: GTMStore = {}

declare global {
  // eslint-disable-next-line @typescript-eslint/ban-types
  const gtag: Function
  interface Window {
    dataLayer?: GTMStore[]
  }
}

enum CookieConsent {
  Accepted = 'accepted',
  Rejected = 'rejected',
}

// NOTE: This value is also in `layout.js`. Both must be updated on change.
const COOKIE_CONSENT_LOCAL_STORAGE_KEY = 'cookieConsent'

const setCookieConsent = (consent: CookieConsent) => {
  localStorage.setItem(COOKIE_CONSENT_LOCAL_STORAGE_KEY, consent)
}

export const shouldDisplayCookieNotice = (): boolean =>
  config.gtmRequireConsent &&
  typeof localStorage !== 'undefined' &&
  localStorage.getItem(COOKIE_CONSENT_LOCAL_STORAGE_KEY) === null

export const setCookieConsentAccepted = () => {
  setCookieConsent(CookieConsent.Accepted)

  // NOTE: Any changes to the gtag command here must be replicated in
  //       layout.js since it cannot import this function

  // This is only called on clicking "Accept" here to not require a page reload.
  // It is also called in `layout.js` on every load for subsequent page loads after
  // accepting

  gtag('consent', 'update', {
    analytics_storage: 'granted',
    ad_storage: 'granted',
  })
}

export const setCookieConsentRejected = () => {
  setCookieConsent(CookieConsent.Rejected)
}

export const report = (props: GTMStore) => {
  store = { ...store, ...props }

  if (props.event && typeof window !== 'undefined' && window.dataLayer) {
    const { event, pageUrlPath, pageType, Brand, cityEntered, vehicleEntered } =
      store

    switch (event) {
      case PAGE_VIEW:
        window.dataLayer.push({
          event,
          pageUrlPath,
        })
        break
      case FORM_1_SUBMIT:
      case FORM_2_SUBMIT:
        window.dataLayer.push({
          event,
          pageType,
          LP_Version: 'new',
          LP_Variation: 'new',
          formElements: 2,
          formLocation: 'side',
          Brand,
          cityEntered,
          vehicleEntered,
        })
        break
      default:
        break
    }
  }
}
